import * as Yup from 'yup';

const sharedBasicSchema = {
    personalInformation: Yup.object().shape({
        name: Yup.string()
            .trim()
            .min(2, 'Imię musi zawierać minimum 2 litery.')
            .required('Pole wymagane'),
        surname: Yup.string().trim().required('Pole wymagane'),
        phone: Yup.string()
            .trim()
            .matches(/^\+?\d{9,15}$/, 'Niepoprawny numer telefonu')
            .required('Pole wymagane'),
        city: Yup.string()
            .trim()
            .min(2, 'Pole musi zawierać przynajmniej 2 znaki.')
            .required('Pole wymagane')
            .test('alphabets', 'Pole może zawierać tylko litery.', (value) =>
                /^[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ\s]+$/.test(value),
            ),
        zipCode: Yup.string()
            .trim()
            .required('Pole wymagane')
            .matches(/^\d{2}-\d{3}$/, 'Nieprawidłowy kod pocztowy'),
        address: Yup.string()
            .trim()
            .min(2, 'Nazwa ulicy musi zawierać minimum 2 litery')
            .required('Pole wymagane'),
        houseNumber: Yup.string().trim().required('Pole wymagane'),
        pesel: Yup.string()
            .trim()
            .required('Pole wymagane')
            .matches(/^\d{11}$/, 'PESEL musi składać się z 11 cyfr')
            .test('pesel-checksum', 'Nieprawidłowy numer PESEL', (value) => {
                if (!value) return false;
                // Wagi według kolejności cyfr PESEL
                const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                const sum = weights.reduce((acc, weight, index) => 
                acc + weight * parseInt(value.charAt(index), 10), 0
                );
                // Obliczenie cyfry kontrolnej
                const checksum = (10 - (sum % 10)) % 10;
                return checksum === parseInt(value.charAt(10), 10);
            }),
    }),
};

export const schema = Yup.object().shape({
    registerEmail: Yup.string().email('Nieprawdiłowy e-mail').required('To pole jest wymagane'),
    password: Yup.string()
        .min(8, 'Hasło musi mieć co najmniej 8 znaków')
        .required('To pole jest wymagane'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Hasła muszą być takie same')
        .required('To pole jest wymagane'),
    acceptRegistrationTerms: Yup.boolean().oneOf([true], 'Musisz zaakceptować regulamin'),
    ...sharedBasicSchema,
});
